module.exports = __webpack_public_path__ + "img/5_Middle-A.c19d0a7d.png";